import React, { useMemo } from 'react';

import { dotFormatter, getLevelConditionValues, isAmountBasedCondition, setTranslationValues } from '../../../../../helpers';
import { LevelConditionShortKeys, T } from '../../../../../constants';
import { useTranslation } from '../../../../../hooks';
import { CashbackLevel } from '../../../../../models';
import { RewardsProgressBar } from '../progress-bar';

interface RewardsLevelProps {
  active: boolean;
  currency: string;
  disabled: boolean;
  color: string;
  data: CashbackLevel;
  onClaimClick: () => void;
  onInfoClick: () => void;
}

export const RewardsLevel: React.FC<RewardsLevelProps> = ({
  data,
  active,
  disabled,
  currency,
  color,
  onClaimClick,
  onInfoClick
}) => {
  const {
    level,
    rewardAmount,
    isCompleted,
    isClaimed,
    levelConditionType,
    goalAmount,
    goalCount,
    currentAmount,
    currentCount,
    progress
  } = data;

  const t = useTranslation();

  const goalContent = useMemo(() => ({
    __html: setTranslationValues(t(LevelConditionShortKeys[levelConditionType]), getLevelConditionValues(data, currency, ''))
  }), [t, data, currency, levelConditionType]);

  const levelContent = useMemo(() => {
    if (isClaimed) {
      return (
        <div className="rewards-ticket-row">
          <p className="rewards-ticket-row-title">
            {t(T.COMPLETED)}
          </p>
        </div>
      );
    }
    if (isCompleted) {
      return (
        <div className="rewards-ticket-row">
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation();
              onClaimClick();
            }}
            className="rewards-ticket-button"
          >
            <span className="rewards-ticket-button-text">
              {t(T.CLAIM)}
            </span>
          </button>
        </div>
      );
    }
    const progressText = isAmountBasedCondition(levelConditionType)
      ? `${dotFormatter(disabled ? 0 : currentAmount)}/${dotFormatter(goalAmount)} ${currency}`
      : `${dotFormatter(disabled ? 0 : currentCount)}/${dotFormatter(goalCount)}`;
    return (
      <RewardsProgressBar
        progress={disabled ? 0 : progress}
        text={progressText}
      />
    );
  }, [isClaimed, isCompleted, onClaimClick, t, levelConditionType, currentAmount, goalAmount, currentCount, goalCount, progress, currency, disabled]);

  return (
    <div
      className={`rewards-body-card ${active ? 'active' : ''} ${disabled ? 'disabled' : ''} ${color}`}
      onClick={onInfoClick}
    >
      <div className="rewards-ticket-info-block">
        <span className="icon-info rewards-ticket-info" />
      </div>
        <div className="rewards-left-title-block">
            <p className="rewards-left-title">
                {t(T.LVL)}
                <span>{level}</span>
            </p>
        </div>
      <div className="rewards-title-ticket-prize">
        <span className="rewards-ticket-title">
          {t(T.PRIZE)}
        </span>
        <p className="rewards-sub-title">
          <span>
            {dotFormatter(rewardAmount)}
          </span>
          <span className="rewards-sub-title-text">
            {currency}
          </span>
        </p>
      </div>
      <p className="total-rounds-text" dangerouslySetInnerHTML={goalContent} />
      {levelContent}
      {
        disabled && (
          <div className="disabled-cover">
            <i className="icon-lock disabled-cover-icon" />
          </div>
        )
      }
    </div>
  );
};
